import { MODULE_NAME as CAMPAIGNS_MODULE } from 'modules/campaigns/config/routes/module';
import { FEATURE_FLAGS } from 'modules/taboola-common-frontend-modules/account-configurations';
import { isSponsoredAccountAndDimension } from '../../../../../config/report-predicates/isSponsoredAccountAndDimension';
import { REPORT_PERMISSION } from '../../../../../config/reportPermissions';
import * as FIELDS from '../../fields';
import { REPORT_PRESET } from '../../pickers';
import columnDefinitions from './columnDefinitions';
import { DMA_REPORT_ID } from './dmaReportId';
import footerColumnDefinitions from './footerColumnDefinitions';
import graph from './graph';
import { defaultColumns, customColumns } from './reportPresets';

export const dmaReportConfig = {
    id: DMA_REPORT_ID,
    label: 'DMAs',
    permissions: [REPORT_PERMISSION.SP_VIEW_SUBCOUNTRY_PERFORMANCE],
    accountConfigurations: { [FEATURE_FLAGS.ONLY_PERFORMANCE_REPORTS]: 'false' },
    visibilityCondition: isSponsoredAccountAndDimension,
    module: CAMPAIGNS_MODULE,
    endpoint: 'campaign-report-by-dma-performance',
    graph,
    rowIdField: FIELDS.DMA_CODE.field,
    columnsDef: columnDefinitions,
    presets: {
        [REPORT_PRESET.DEFAULT]: { columns: defaultColumns },
    },
    customPreset: { columns: customColumns, initialState: defaultColumns },
    footerColumnDef: footerColumnDefinitions,
    searchPlaceholderMsgId: 'app.reports.byDMA.search.placeholder',

    // TODO: DEV-58584 need to convert filter names in the GW. replace searchField + remove sortMap
    searchField: 'dmaName',
    sortMap: {
        [FIELDS.DMA_CODE.field]: 'dma',
        [FIELDS.CVR.field]: 'cpaConversionRate',
        [FIELDS.AVERAGE_CPC.field]: 'cpc',
        [FIELDS.CONVERSIONS.field]: 'cpaActionsNum',
        [FIELDS.CONVERSIONS_CLICKS.field]: 'cpaActionsNumFromClicks',
        [FIELDS.CONVERSIONS_VIEWS.field]: 'cpaActionsNumFromViews',
        [FIELDS.CVR.field]: 'cpaConversionRate',
        [FIELDS.CVR_CLICKS.field]: 'cpaConversionRateClicks',
        [FIELDS.CVR_VIEWS.field]: 'cpaConversionRateViews',
    },
};

export default dmaReportConfig;
